import { Globe, Smartphone, Link, FileText, ShoppingCart, Repeat, Code, MonitorSmartphone } from 'lucide-react';

// Channel icons mapping
export const channelIconMap = {
  'web': { icon: Globe, color: 'text-blue-500', bg: 'bg-blue-50', label: 'Web' },
  'mobile_app': { icon: Smartphone, color: 'text-purple-500', bg: 'bg-purple-50', label: 'Mobile App' },
  'mobile_web': { icon: MonitorSmartphone, color: 'text-indigo-500', bg: 'bg-indigo-50', label: 'Mobile Web' },
  'api': { icon: Code, color: 'text-gray-600', bg: 'bg-gray-100', label: 'API' },
  'pos': { icon: ShoppingCart, color: 'text-green-500', bg: 'bg-green-50', label: 'POS' },
  'recurring': { icon: Repeat, color: 'text-amber-500', bg: 'bg-amber-50', label: 'Subscription' },
  'email_link': { icon: Link, color: 'text-cyan-500', bg: 'bg-cyan-50', label: 'Email Link' },
  'manual_link': { icon: Link, color: 'text-teal-500', bg: 'bg-teal-50', label: 'Manual Link' },
  'file_link': { icon: FileText, color: 'text-orange-500', bg: 'bg-orange-50', label: 'File Link' }
};

export const getChannelIcon = (code) => {
  return channelIconMap[code] || { icon: Globe, color: 'text-gray-400', bg: 'bg-gray-50', label: code || 'Unknown' };
};

export default getChannelIcon;
